<div class="pt-3">
    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
        <div class="row search-area">
            <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                    <mat-label>Pesquisar</mat-label>
                    <input matInput type="text" formControlName="pesquisa" placeholder="UF, nome da UF...">
                    <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div class="col-12 col-lg-6 filter-container">
                <button #filtrosMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-filter"
                    [matMenuTriggerFor]="filtroMenu" [matBadge]="qtdFiltrosAvancados"
                    [matBadgeHidden]="qtdFiltrosAvancados === 0">
                    <mat-icon>filter_list</mat-icon>
                    Filtrar
                </button>

                <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
                    <div class="filter-menu-content" [formGroup]="model" (click)="$event.stopPropagation()">
                        <h6>Filtros</h6>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Região</mat-label>
                            <mat-select formControlName="regiao">
                                @for (opt of regiaoOptions; track opt.value) {
                                <mat-option [value]="opt.value">{{opt.label}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Origem da fórmula</mat-label>
                            <mat-select formControlName="origem">
                                @for (opt of origemOptions; track opt.id) {
                                <mat-option [value]="opt.id">{{opt.label}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-checkbox formControlName="somenteReducaoBc">Somente com redução de BC</mat-checkbox>

                        <div class="filter-menu__actions">
                            <button mat-button class="btn-secondary" matMenuClose
                                (click)="filtrosMenuTrigger.closeMenu()">Cancelar</button>
                            <button mat-flat-button class="btn-primary" matMenuClose
                                (click)="aplicarFiltros()">Aplicar</button>
                        </div>
                    </div>
                </mat-menu>

                <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                    <mat-icon>cleaning_services</mat-icon>
                    Limpar Filtros
                </button>
            </div>
        </div>
    </form>

    @if (_isLoading && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (_dataSource.data.length > 0) {

    <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>

        <ng-container matColumnDef="uf">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>UF de Destino</th>
            <td mat-cell *matCellDef="let element">
                <div class="badges-row">
                    <span class="status-badge" [ngClass]="corBadgeRegiao(element.regiaoEnum)">{{element.regiao}}</span>
                    <span class="status-badge badge-cinza">{{element.nomeUf}} - {{element.siglaUf}}</span>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="pIcmsUfDest">
            <th mat-header-cell *matHeaderCellDef>Alíquota interna da UF de destino</th>
            <td mat-cell *matCellDef="let element">{{formatarPercentual(element.pIcmsUfDest)}}</td>
        </ng-container>

        <ng-container matColumnDef="pIcmsInter">
            <th mat-header-cell *matHeaderCellDef>Alíquota interestadual</th>
            <td mat-cell *matCellDef="let element">
                {{formatarPercentual(element.pIcmsInter)}}
            </td>
        </ng-container>

        <ng-container matColumnDef="pFcpUfDest">
            <th mat-header-cell *matHeaderCellDef>Alíquota do FCP</th>
            <td mat-cell *matCellDef="let element">
                {{formatarPercentual(element.pFcpUfDest)}}
            </td>
        </ng-container>

        <ng-container matColumnDef="reducaoBc">
            <th mat-header-cell *matHeaderCellDef>Redução da Base de Cálculo</th>
            <td mat-cell *matCellDef="let element">
                @if (element.isReducaoBc) {
                {{formatarPercentual(element.pRedBcDifal)}}
                } @else {
                <span class="text-secondary cell-detail">—</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="origemFormula">
            <th mat-header-cell *matHeaderCellDef>Origem da fórmula</th>
            <td mat-cell *matCellDef="let element">
                <span class="status-badge" [ngClass]="classeOrigem(element)">
                    {{rotuloOrigem(element)}}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let element" class="text-center w-actions">
                <button mat-icon-button [matMenuTriggerFor]="menuAcoes" aria-label="Ações">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuAcoes="matMenu">
                    <button mat-menu-item (click)="editar(element)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="mobile-view">
        @for (item of _dataSource.data; track item.idDifal) {
        <div class="card-mobile mb-3">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <div class="badges-row">
                    <span class="status-badge badge-cinza">{{item.nomeUf}} - {{item.siglaUf}}</span>
                    <span class="status-badge" [ngClass]="corBadgeRegiao(item.regiaoEnum)">{{item.regiao}}</span>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menuMob">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuMob="matMenu">
                    <button mat-menu-item (click)="editar(item)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
                <p class="mb-1"><strong>Alíquota interna da UF de destino:</strong>
                    {{formatarPercentual(item.pIcmsUfDest)}}</p>
                <p class="mb-1"><strong>Alíquota interestadual:</strong> {{formatarPercentual(item.pIcmsInter)}}</p>
                <p class="mb-1"><strong>Alíquota do FCP:</strong> {{formatarPercentual(item.pFcpUfDest)}}</p>
                <p class="mb-1">
                    <strong>Redução da Base de Cálculo:</strong>
                    @if (item.isReducaoBc) {
                    <span class="status-badge badge-turquesa ms-1">{{formatarPercentual(item.pRedBcDifal)}}</span>
                    } @else {
                    <span class="text-secondary ms-1">—</span>
                    }
                </p>
                <p class="mb-0">
                    <strong>Origem:</strong>
                    <span class="status-badge ms-1" [ngClass]="classeOrigem(item)">
                        {{rotuloOrigem(item)}}
                    </span>
                </p>
            </div>
        </div>
        }
    </div>

    <div class="col-12 text-center mt-4 mb-5">
        <button mat-button class="btn-ver-mais btn-spinner" [class.btn-loading]="_isLoading" [attr.aria-label]="_isLoading ? 'Carregando mais registros' : 'Ver mais'" [disabled]="_isLoading || !_possuiProximaPagina"
            (click)="proximaPagina()">
            <span class="material-symbols-outlined">expand_more</span>
            Ver Mais
            @if (_isLoading) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
    </div>

    } @else {
    <app-empty-list [title]="'Nenhuma configuração DIFAL encontrada'"
        [subTitle]="'Ajuste os filtros para visualizar a matriz de alíquotas por UF.'">
    </app-empty-list>
    }
</div>
